// extracted by mini-css-extract-plugin
module.exports = {"McsHeaderWrap":"McsHeaderComment_McsHeaderWrap__tfkOB","McsHeaderButton":"McsHeaderComment_McsHeaderButton__3E1Ty","McsHeaderTitle":"McsHeaderComment_McsHeaderTitle__2WfBo"};